<template>
  <card class="flat" body-classes="p-0" footer-classes="pb-2">
    <b-card-body v-if="loading" class="d-flex justify-content-center">
      <b-spinner label="Loading..."></b-spinner>
    </b-card-body>
    <el-table :data="queriedData" @sort-change="sortChange">
      <el-table-column
        min-width="120"
        prop="create_date"
        label="Date"
        :sortable="true"
      >
        <template #default="{row}">
          {{ row.create_date | toDateTimeFormat }}
        </template>
      </el-table-column>
      <el-table-column
        min-width="120"
        prop="file_name"
        label="File Name"
        :sortable="true"
      >
        <template #default="{row}">
          {{ row.file_name | toShortFileName(50) }}
        </template>
      </el-table-column>
      <el-table-column
        min-width="120"
        prop="word_count"
        label="Word Count"
        :sortable="true"
      ></el-table-column>
      <el-table-column
        min-width="120"
        prop="work_status"
        label="Work Status"
        :sortable="true"
      >
        <template #default="{row}">
          {{ row.status | toStatusMapText }}
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="col-12 d-flex justify-content-center flex-wrap">
      <base-pagination
        class="pagination-no-border"
        ref="pagination"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import { Table, TableColumn } from 'element-ui'
import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin'
import { BasePagination } from '@/components'
export default {
  components: {
    BasePagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  mixins: [clientPaginationMixin],
  props: {
    files: Array,
    loading: Boolean,
  },
  computed: {
    tableData() {
      return this.files || []
    },
  },
}
</script>

<style lang="scss" scoped></style>
